const initialState = {
  step: 0,
  answers: {},
  screen: "START",
};

const questionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_SCREEN": {
      return {
        ...state,
        [`screen_${action.payload.screen}`]: {
          id: 1,
          show: true,
          answer: "",
        },
      };
    }
    case "UPDATE_SCREEN": {
      return {
        step: state.step + 1,
        answers: {
          ...state.answers,
          [`${action.payload.curr_screen}`]: action.payload.answer,
        },
        screen: action.payload.next_screen,
      };
    }
    case "BACK_SCREEN": {
      return {
        step: state.step - 1,
        answers: {
          ...state.answers,
        },
        screen: action.payload.back_screen,
      };
    }
    case "RESET": {
      return initialState;
    }
    default:
      return state;
  }
};
export default questionsReducer;
